import React from "react";

import ptBr from "../../../config/texts/pt-br";
import {
  ButtonText,
  CustomText,
  FontStyles,
  Input,
  InputAutocomplete,
  InputDate,
  Tooltip,
} from "../../../components/index";
import Styles from "../styles";
import { ErrorMessageType, FormFull } from "form-full";
import { hooks, masks, validations } from "../../../utils";

import { fonts, Spacing } from "../../../config";
import {
  Grid,
  Checkbox,
  FormControlLabel,
  IconButton,
} from "@material-ui/core";
import { customModal } from "../../../components/modals/utils";
import alerts from "../../../utils/alerts";
import { api } from "../../../services";
import colors from "../../../config/colors";
import SelectComponent from "../../../components/inputs/Select";
import { AccessTime, Label, FileCopy, Person } from "@material-ui/icons";
import errorResponseMessage from "../../../services/helpers/getErrorMessage";
import ResponseError from "../../../services/helpers/ResponseError";
import errorStatusMessage from "../../../services/helpers/errorStatusMessage";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import "../../../phone.css";
import { LabelView } from "../../../components/inputs/Input";
import styled from "styled-components";
import InputPhone from "../../../components/inputs/InputPhone";

import ButtonMenu from "../../../components/buttons/ButtonMenu";
import { Visibility } from "@material-ui/icons";

interface ExtraGuest {
  fullName: string;
  email: string;
}

interface GuestInfo {
  name?: string;
  cpf?: string;
  birthDate?: string;
  email?: string;
  phone?: string;
  id?: string | undefined | null;
  passport?: string;
  document?: string;
  vehiclePlate?: string;
}
interface FormSendData {
  id: string;
  role: string;
  property: string;
  numGuests: number;
  placeId: string;
  startDate: string;
  endDate: string;
  checkOutTime: string;
  checkInTime: string;
  fullName: string;
  passport?: string;
  document?: string;
  birthday: string;

  vehiclePlate?: string;
  email: string;
  phone: string;
  numberUsers: number;
  primaryGuest: GuestInfo;
  secondaryGuests: Partial<ExtraGuest>[];
  docType: number;

  docValue: string;
}

export const MyLabel = styled.p(({ theme, $withError, $color, white }) => {
  const { palette: colors } = theme;
  return {
    ...FontStyles.semibold14,
    textTransform: "uppercase",
    padding: 0,
    paddingBottom: 10,
    margin: 0,
    color: $withError
      ? colors.error.main
      : white
      ? "white"
      : colors.action.selected,
    transition: ".2s",
    pointerEvents: "none",
    alignItems: "center",
    display: "flex",
    overflow: "hidden",
  };
});

function RegistryReservation({
  reload,
  placeList,
  page,
  edit,
  oldData,
  optionsProfiles,
}: {
  reload: (data: any) => void;
  placeList: { value: string; label: string; params: any }[]; // Arrumar a tipagem
  page: number;
  edit?: boolean;
  oldData?: any;
  optionsProfiles?: { value: string; label: string }[];
}) {
  const texts = ptBr.login;
  const { loading, call } = hooks.useRequest();

  const [totalMembers, setTotalMembers] = React.useState(0);
  const [formRef, setFormRef] = React.useState<any>(null);
  const [minDate, setMinDate] = React.useState<any>(() => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday;
  });
  const [unError, setUnError] = React.useState<any>(false);
  const [timeError, setTimeError] = React.useState<any>(false);
  const [hourError, setHourError] = React.useState<any>(false);
  const [warning, setWarning] = React.useState<any>(false);
  const [docType, setDocType] = React.useState<any>(1);

  // Display Campos de cadastro
  const [showName, setShowName] = React.useState(true);
  const [showDoc, setShowDoc] = React.useState(true);
  const [showBirthday, setShowBirthday] = React.useState(true);
  const [showEmail, setShowEmail] = React.useState(true);
  const [showPhone, setShowPhone] = React.useState(true);
  const [showPlate, setShowPlate] = React.useState(true);
  const [showFacial, setShowFacial] = React.useState(true);
  const [showRenterPassword, setShowRenterPassword] = React.useState(true);
  const [showReservationPassword, setShowReservationPassword] =
    React.useState(true);
  const [showFacialURL, setShowFacialURL] = React.useState(true);

  // Facial choices
  const [confirmUseFacial, setConfirmUseFacial] =
    React.useState<boolean>(false);
  const [requestNewFacial, setRequestNewFacial] =
    React.useState<boolean>(false);

  const otherphones = React.useRef<any>([]);

  const [editValues, setEditValues] = React.useState<
    Partial<FormSendData> | undefined
  >(
    oldData
      ? {
          role: oldData?.subType,
          property: oldData?.place?.id,
          startDate: oldData?.startDate,
          checkInTime: oldData?.startDate.split("T")[1],
          checkOutTime: oldData?.endDate.split("T")[1],
          endDate: oldData?.endDate,
          docType:
            oldData?.primaryGuest?.document &&
            Boolean(oldData?.primaryGuest?.document)
              ? 1
              : 2,
          fullName: oldData?.primaryGuest?.name,
          birthday: oldData?.primaryGuest?.birthDate,
          email: oldData?.primaryGuest?.email,
          phone: oldData?.primaryGuest?.phone,
          vehiclePlate: oldData?.primaryGuest?.vehiclePlate,
          numberUsers: oldData?.numGuests,
        }
      : {
          checkInTime: "15:00",
          checkOutTime: "11:00",
        }
  );

  React.useEffect(() => {
    if (!oldData) return;
    oldData?.secondaryGuests.forEach(
      (element, index) => (otherphones.current[index] = element.phone)
    );
  }, []);

  React.useEffect(() => {
    if (!formRef) return;
    let extraGuests: any = {};

    oldData?.secondaryGuests.forEach((element, index) => {
      extraGuests["fullName" + (index + 1)] = element?.name;
      extraGuests["email" + (index + 1)] = element?.email;
      extraGuests["birthday" + (index + 1)] = element?.birthDate;
      extraGuests["phone" + (index + 1)] = element?.phone;
    });

    if (
      oldData?.primaryGuest?.document &&
      Boolean(oldData?.primaryGuest?.document)
    ) {
      extraGuests["docValue"] = oldData?.primaryGuest?.document;
      setDocType(1);
    } else if (
      oldData?.primaryGuest?.passport &&
      Boolean(oldData?.primaryGuest?.passport)
    ) {
      extraGuests["docValue"] = oldData?.primaryGuest?.passport;
      setDocType(2);
    }

    setEditValues((v) => {
      return { ...v, ...extraGuests };
    });
  }, [totalMembers, formRef]);

  // const copyCpfToClipboard = async () => {
  //   const cpf =
  //     formRef?.getValue("docValue", false) ||
  //     oldData?.primaryGuest?.document ||
  //     "";
  //   if (!cpf) {
  //     alerts.alertError("Nenhum CPF disponível para copiar");
  //     return;
  //   }
  //   try {
  //     if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
  //       await navigator.clipboard.writeText(cpf);
  //       alerts.setErrorModal(
  //         "Copiado",
  //         ["CPF copiado para a área de transferência."],
  //         null,
  //         "Ok"
  //       );
  //     } else {
  //       const textarea = document.createElement("textarea");
  //       textarea.value = cpf;
  //       textarea.style.position = "fixed";
  //       textarea.style.opacity = "0";
  //       document.body.appendChild(textarea);
  //       textarea.select();
  //       document.execCommand("copy");
  //       document.body.removeChild(textarea);
  //       alerts.setErrorModal(
  //         "Copiado",
  //         ["CPF copiado para a área de transferência."],
  //         null,
  //         "Ok"
  //       );
  //     }
  //   } catch (e) {
  //     alerts.alertError("Não foi possível copiar o CPF");
  //   }
  // };

  const drawMembers = (number: number) => {
    const membersForm: any = [];

    for (let index = 0; index < number; index++) {
      membersForm.push(
        <>
          <Styles.Barra />
          <CustomText
            fontFamily={fonts.bold}
            fontSize={14 / 8}
            textColor="#272727"
            style={{ paddingTop: "12px", paddingBottom: "4px" }}
          >
            ACOMPANHANTE #{index + 1}
          </CustomText>
          <Grid alignItems="flex-end" container spacing={1}>
            <Grid item xs={12} md={12} lg={3}>
              <Input
                disableError
                name={"fullName" + (index + 1)}
                label="Nome Completo"
                validation={validations.isValidFullname}
              />
            </Grid>
            <Grid item xs={12} md={12} lg={3}>
              <Input
                disableError
                validation={validations.isEmailValid}
                name={"email" + (index + 1)}
                label="E-Mail"
              />
            </Grid>

            <Grid item xs={12} md={6} lg={3}>
              <InputPhone
                disableError
                placeholder="99 99999-9999"
                label="Telefone"
                name={"phone" + (index + 1)}
                defaultValue={otherphones.current[index]}
                onChange={(newPhone: any) => {
                  otherphones.current[index] = newPhone;
                }}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <InputDate
                disableError
                maxDate={new Date()}
                name={"birthday" + (index + 1)}
                label="DATA NASCIMENTO"
              />{" "}
            </Grid>
            {/* <Grid item xs={12} md={6} lg={3}>
              <Input
                disableError
                name={"vehiclePlate" + (index + 1)}
                label="Placa do Veículo"
                white
              />
            </Grid> */}
          </Grid>
        </>
      );
    }
    return membersForm;
  };

  // Função auxiliar para gerar opções do ButtonMenu (evita erro se não existir)
  const getButtons = (itemGuest: any, fullItem: any) => {
    // Se houver imageId, mostra opção de visualizar; caso contrário, oferece ação padrão
    if (!itemGuest) return [];

    if (!itemGuest.imageId) {
      return [
        {
          label: "Tirar Foto",
          onClick: () => {
            customModal.setInfos(
              "Assinatura Facial",
              [itemGuest?.facialUrl || ""],
              {
                onClick: () => customModal.close(),
                label: "Voltar",
              },
              null,
              null,
              false,
              true,
              <Visibility />
            );
          },
        },
      ];
    }

    return [
      {
        label: "Visualizar",
        onClick: () => {
          customModal.setInfos(
            "Link da Imagem",
            [itemGuest?.facialUrl || ""],
            {
              onClick: () => customModal.close(),
              label: "Voltar",
            },
            null,
            null,
            false,
            true,
            <Visibility />
          );
        },
      },
    ];
  };

  const newReservation = async (data) => {
    const submitDate: Partial<FormSendData> = {
      numGuests: data.numberUsers ? parseInt(data.numberUsers) : 0,
      placeId: data.property,
      startDate: masks.dateToSubmit(data.startDate) + " " + data?.checkInTime,
      endDate: masks.dateToSubmit(data.endDate) + " " + data?.checkOutTime,
      primaryGuest: {
        name: data.fullName,
        document:
          data.docType === 1 || data.docType === "1"
            ? data.docValue
            : undefined,
        passport:
          data.docType === 2 || data.docType === "2"
            ? data.docValue
            : undefined,
        birthDate: masks.dateToSubmit(data.birthday),
        email: data.email,
        phone: data.phone,
        vehiclePlate: masks.removePlacaMask(data.vehiclePlate),
      },
      secondaryGuests: [],
    };

    const secondaryGuests: Partial<ExtraGuest>[] = [];

    if (parseInt(data.numberUsers) > 0) {
      for (let index = 1; index < data.numberUsers + 1; index++) {
        if (data["fullName" + index] || data["email" + index]) {
          let newGuest = {} as any;
          if (data["fullName" + index]) {
            newGuest["name"] = data["fullName" + index];
          }
          if (data["email" + index]) {
            newGuest["email"] = data["email" + index];
          }
          if (data["phone" + index]) {
            newGuest["phone"] = data["phone" + index];
          }
          if (data["birthday" + index]) {
            newGuest["birthDate"] = masks.dateToSubmit(
              data["birthday" + index]
            );
          }
          secondaryGuests.push(newGuest);
        }
      }
      submitDate.secondaryGuests = secondaryGuests;
    }

    if (edit) {
      delete submitDate.placeId;
      submitDate["id"] = oldData.id;

      submitDate.secondaryGuests = submitDate.secondaryGuests?.map(
        (i, index) => {
          return { ...i, id: oldData?.secondaryGuests[index]?.id };
        }
      );
      submitDate.primaryGuest = {
        ...submitDate.primaryGuest,
        id: oldData?.primaryGuest?.id,
      };
      call(null, api.patchReservation(submitDate), async (response) => {
        if (response.ok) {
          customModal.close();
          reload(page);
          alerts.setErrorModal(
            "Reserva Editada",
            ["Reserva editada com sucesso!"],
            null,
            "Ok, Entendi",
            "#0C396D"
          );
        }
      });
    } else {
      call(null, api.postReservation(submitDate), async (response) => {
        if (response.ok) {
          customModal.close();
          reload(page);
          alerts.setErrorModal(
            "Reserva Cadastrada",
            ["Reserva cadastrada com sucesso!"],
            null,
            "Ok, Entendi",
            "#0C396D"
          );
        }
      });
    }
  };

  const customDateValid = (data, maxDate, minDate): ErrorMessageType => {
    const error = validations.inputDate(data, maxDate, minDate);
    setTimeError(Boolean(error) ? "*Período invalido" : null);
    return error;
  };

  const addOneDay = (date) => {
    const result = new Date(date);
    result.setDate(result.getDate() + 1);
    return result;
  };

  function isValidDate(date: any): boolean {
    const parsedDate = new Date(date);
    return parsedDate instanceof Date && !isNaN(parsedDate.getTime());
  }

  const validadeTime = () => {
    const localId = formRef?.getValue("property", false);
    const startDate = formRef?.getValue("startDate", false);
    const endDate = formRef?.getValue("endDate", false);
    const startHour = formRef?.getValue("checkInTime", false);
    const endHour = formRef?.getValue("checkOutTime", false);

    const timeEndError = validations.validateTimeRange(endHour);
    const timeStartHour = validations.validateTimeRange(startHour);

    if (
      !timeEndError &&
      !timeStartHour &&
      isValidDate(startDate) &&
      isValidDate(endDate) &&
      localId &&
      endDate &&
      endHour &&
      startDate &&
      startHour
    ) {
      const startSub = masks.dateToSubmit(startDate) + " " + startHour;
      const endSub = masks.dateToSubmit(endDate) + " " + endHour;

      let subData = {
        placeId: localId,
        startDate: startSub,
        endDate: endSub,
      };

      if (edit) subData["reservationId"] = oldData.id;

      call(
        null,
        api.validadeTime(subData),
        (response) => {
          if (response?.ok) {
            setHourError(null);
            if (response?.data?.value === true)
              setWarning("Esse horário esta em uso");
          }
        },
        (response) => {
          const errorResponse = new ResponseError(response);
          if (errorResponse.message) {
            setHourError(errorResponse.message);
          } else {
            const errorMsg = errorStatusMessage(response);

            alerts.alertError(errorMsg);
            setHourError(
              "*Não foi possível validar o horário. Tente Novamente"
            );
          }
        }
      );
    } else {
      setHourError("Selecione um Local e Período");
    }
  };

  function checkStartData(): boolean {
    //Devolve se a data selecionada é igual a inicial ou menor que a atual.
    const startDate = formRef?.getValue("startDate", false);

    // if (oldData) {
    //   if (
    //     !(oldData?.startDate < startDate) &&
    //     !(oldData?.startDate > startDate)
    //   ) {
    //     return true;
    //   }
    // }

    return startDate < new Date();
  }

  const customDateValidStartData = (
    data,
    maxDate,
    minDate
  ): ErrorMessageType => {
    if (data + "" === oldData?.startDate + "") {
      setTimeError(null);
      return;
    }
    const error = validations.inputDate(data, maxDate, minDate);
    setTimeError(Boolean(error) ? "*Período invalido" : null);
    return error;
  };

  function showInputs(placeID: string | undefined) {
    const fieldConfig = {
      GUEST_SHEET_NAME_ENABLED: setShowName,
      GUEST_SHEET_DOCUMENT_ENABLED: setShowDoc,
      GUEST_SHEET_BIRTHDATE_ENABLED: setShowBirthday,
      GUEST_SHEET_EMAIL_ENABLED: setShowEmail,
      GUEST_SHEET_PHONE_ENABLED: setShowPhone,
      GUEST_SHEET_VEHICLE_PLATE_ENABLED: setShowPlate,
      GUEST_SHEET_FACIAL_ENABLED: setShowFacial,
      GUEST_SHEET_RENTER_PASSWORD_ENABLED: setShowRenterPassword,
      GUEST_SHEET_RESERVATION_PASSWORD_ENABLED: setShowReservationPassword,
      GUEST_SHEET_FACIAL_URL_ENABLED: setShowFacialURL,
    };

    const resetAllFields = (value: boolean) =>
      Object.values(fieldConfig).forEach((setter) => setter(value));
    if (!placeID) return resetAllFields(true);
    const place = placeList?.find((p) => p.value === placeID);

    if (!place?.params) return resetAllFields(true);

    const normalize = (value: any): boolean => {
      if (typeof value === "boolean") return value;
      const str = String(value ?? "")
        .toLowerCase()
        .trim();
      return str === "true" || str === "1";
    };
    resetAllFields(true);
    place.params.forEach((param: any) => {
      const setter = fieldConfig[param.type as keyof typeof fieldConfig];
      if (setter) setter(normalize(param.value));
    });
  }

  // Initialize visibility when editing or when the place list becomes available
  React.useEffect(() => {
    if (oldData?.place?.id) showInputs(oldData.place.id);
  }, [placeList, oldData?.place?.id]);

  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          minWidth: "clamp(300px, 54vw, 1055px)",
          paddingInline: "25px",
        }}
      >
        <FormFull
          formRef={setFormRef}
          onSubmit={(data) => {
            for (let index = 0; index < otherphones.current.length; index++) {
              data["phone" + (index + 1)] = otherphones.current[index];
            }

            newReservation(data);
          }}
          currentValues={editValues}
        >
          <Grid
            alignItems="center"
            container
            spacing={2}
            style={{ width: "100%" }}
          >
            {/* Imagem à esquerda */}
            {!edit && (
              <Grid item xs={12} md={12} lg={2}>
                <Styles.ImageLabel>Assinatura Facial</Styles.ImageLabel>
                <Styles.ImageBox>
                  {oldData?.primaryGuest?.imageId ? (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                      }}
                    >
                      {oldData?.primaryGuest?.facialUrl ? (
                        <img
                          src={oldData?.primaryGuest?.facialUrl}
                          alt="Facial"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: 8,
                          }}
                        />
                      ) : null}

                      <div
                        style={{ position: "absolute", bottom: 8, right: 8 }}
                      >
                        <ButtonMenu
                          endIcon={<Visibility />}
                          buttons={getButtons(oldData?.primaryGuest, oldData)}
                        >
                          Visualizar
                        </ButtonMenu>
                      </div>

                      <div
                        style={{
                          marginTop: 8,
                          display: "flex",
                          flexDirection: "column",
                          gap: 6,
                        }}
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={confirmUseFacial}
                              onChange={(e) =>
                                setConfirmUseFacial(e.target.checked)
                              }
                              color="primary"
                            />
                          }
                          label="Confirmar uso desta facial"
                        />

                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={requestNewFacial}
                              onChange={(e) =>
                                setRequestNewFacial(e.target.checked)
                              }
                              color="default"
                            />
                          }
                          label="Solicitar nova"
                        />
                      </div>
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                        position: "relative",
                      }}
                    >
                      <Person style={{ fontSize: 130, color: "#9e9e9e" }} />
                      {/* <div style={{ position: "absolute", bottom: 8, left: 190}}>
                      <IconButton
                        size="small"
                        // onClick={copyCpfToClipboard}
                        aria-label="copiar-cpf"
                      >
                        <FileCopy style={{ fontSize: 18 }} />
                      </IconButton>
                    </div> */}
                    </div>
                  )}
                </Styles.ImageBox>
              </Grid>
            )}

            {/* Campos à direita (nested grid) */}
            <Grid
              item
              xs={12}
              md={12}
              lg={edit ? 12 : 10}
              className="inputs-grid"
            >
              <Grid container spacing={3} alignItems="flex-end">
                <Grid item xs={12} md={3}>
                  <SelectComponent
                    disableError
                    name="profile"
                    label="Perfil"
                    defaultValue={
                      optionsProfiles?.find((p) => p.value === oldData?.subType)
                        ?.value
                    }
                    options={optionsProfiles ? optionsProfiles : []}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <InputAutocomplete
                    readOnly={edit}
                    defaultValue={oldData?.place?.id}
                    disableError
                    required={"*Campo Obrigatório"}
                    name="property"
                    label="Imóvel"
                    options={placeList ? placeList : []}
                    onBlur={() => {
                      validadeTime();
                      showInputs(formRef?.getValue("property"));
                    }}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={3}
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                    gap: "0.5rem",
                  }}
                >
                  <InputDate
                    onBlur={validadeTime}
                    disableError
                    required={"*Campo Obrigatório"}
                    onChange={(value) => {
                      setMinDate(value);
                      const end = formRef?.getValue("endDate");
                      if (end < value) {
                        formRef?.clearValue("endDate", false);
                      }
                    }}
                    name="startDate"
                    customValidation={customDateValidStartData}
                    minDate={new Date()}
                    label="Check-in"
                  />
                  <Input
                    onBlur={validadeTime}
                    disableError
                    required={"*Campo Obrigatório"}
                    mask={masks.formatHour}
                    placeholder="00:00"
                    validation={validations.validateTimeRange}
                    name="checkInTime"
                    endAdornment={
                      <AccessTime style={{ fontSize: Spacing(2) }} />
                    }
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={3}
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                    gap: "0.5rem",
                  }}
                >
                  <InputDate
                    disableError
                    required={"*Campo Obrigatório"}
                    minDate={minDate}
                    name="endDate"
                    customValidation={customDateValid}
                    onBlur={validadeTime}
                    label="Check-out"
                  />
                  <Input
                    endAdornment={
                      <AccessTime style={{ fontSize: Spacing(2) }} />
                    }
                    disableError
                    required={"*Campo Obrigatório"}
                    mask={masks.formatHour}
                    placeholder="00:00"
                    validation={validations.validateTimeRange}
                    name="checkOutTime"
                    onBlur={validadeTime}
                  />
                  {/* </div> */}
                </Grid>

                {showDoc ? (
                  <Grid item xs={12} md={6} lg={3}>
                    <SelectComponent
                      disableError
                      required={"*Campo Obrigatório"}
                      name="docType"
                      label="Tipo do Documento"
                      defaultValue={1}
                      onBlurCustom={() =>
                        formRef?.testFieldError("documento", true)
                      }
                      onChangeCustom={(v) => {
                        setDocType(v);
                        formRef?.clearValue("docValue", true);
                        v === 1
                          ? formRef?.setFieldValidation(
                              "docValue",
                              validations.validateCPF
                            )
                          : formRef?.setFieldValidation("docValue", () => null);
                      }}
                      options={[
                        { value: 1, label: "CPF" },
                        { value: 2, label: "Passaporte" },
                      ]}
                    />
                  </Grid>
                ) : null}

                {showDoc ? (
                  <Grid item xs={12} md={6} lg={3}>
                    <Input
                      disableError
                      required={"*Campo Obrigatório"}
                      mask={docType === 1 ? masks.CPF : undefined}
                      name="docValue"
                      label={"Nº Documento"}
                      maskToSubmit={(e, ffHandler) => {
                        let type = ffHandler?.getValue("docType", false);
                        return type === 1 ? masks.removeNumberMask(e) : e;
                      }}
                      validation={(e, ffHandler) => {
                        let type = ffHandler?.getValue("docType", false);
                        return type === 1
                          ? validations.validateCPF(e)
                          : undefined;
                      }}
                      customBlur={(value: any) => {
                        var doc = masks.removeNumberMask(value);
                        if (doc.length > 0) {
                          if (docType === 2) {
                            call(
                              null,
                              api.validadePassport(doc),
                              async (response) => {
                                if (response.ok && response.data.length > 0) {
                                  try {
                                    formRef?.setValue(
                                      "fullName",
                                      response.data[0].name
                                    );
                                  } catch (error) {
                                    console.log(error);
                                  }
                                  try {
                                    formRef?.setValue(
                                      "phone",
                                      response.data[0].phone
                                    );
                                  } catch (error) {
                                    console.log(error);
                                  }
                                  try {
                                    formRef?.setValue(
                                      "email",
                                      response.data[0].email
                                    );
                                  } catch (error) {
                                    console.log(error);
                                  }
                                  try {
                                    formRef?.setValue(
                                      "birthday",
                                      response.data[0].birthDate
                                    );
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }
                              }
                            );
                          } else {
                            call(
                              null,
                              api.validadeCPF(doc),
                              async (response) => {
                                if (response.ok && response.data.length > 0) {
                                  try {
                                    formRef?.setValue(
                                      "fullName",
                                      response.data[0].name
                                    );
                                  } catch (error) {
                                    console.log(error);
                                  }
                                  try {
                                    formRef?.setValue(
                                      "phone",
                                      response.data[0].phone
                                    );
                                  } catch (error) {
                                    console.log(error);
                                  }
                                  try {
                                    formRef?.setValue(
                                      "email",
                                      response.data[0].email
                                    );
                                  } catch (error) {
                                    console.log(error);
                                  }
                                  try {
                                    formRef?.setValue(
                                      "birthday",
                                      response.data[0].birthDate
                                    );
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }
                              }
                            );
                          }
                        }
                      }}
                      onChange={(e, ffHandler) => {
                        let type = ffHandler?.getValue("docType", false);
                        var doc = "";
                        if (type === 1) {
                          doc = masks.removeNumberMask(e);
                          if (doc.length > 11) doc = doc.substring(0, 11);
                          if (doc.length === 11) {
                            call(
                              null,
                              api.validadeCPF(doc),
                              async (response) => {
                                if (response.ok && response.data.length > 0) {
                                  try {
                                    formRef?.setValue(
                                      "fullName",
                                      response.data[0].name
                                    );
                                  } catch (error) {
                                    console.log(error);
                                  }
                                  try {
                                    formRef?.setValue(
                                      "phone",
                                      response.data[0].phone
                                    );
                                  } catch (error) {
                                    console.log(error);
                                  }
                                  try {
                                    formRef?.setValue(
                                      "email",
                                      response.data[0].email
                                    );
                                  } catch (error) {
                                    console.log(error);
                                  }
                                  try {
                                    formRef?.setValue(
                                      "birthday",
                                      response.data[0].birthDate
                                    );
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }
                              }
                            );
                          }
                        } else {
                        }
                      }}
                    />
                  </Grid>
                ) : null}

                {showName ? (
                  <Grid item xs={12} md={6} lg={3}>
                    <Input
                      disableError
                      required={"*Campo Obrigatório"}
                      name="fullName"
                      validation={validations.isValidFullname}
                      label="Nome Completo"
                    />
                  </Grid>
                ) : null}

                {showBirthday ? (
                  <Grid item xs={12} md={6} lg={3}>
                    <InputDate
                      disableError
                      required={"*Campo Obrigatório"}
                      maxDate={new Date()}
                      name="birthday"
                      label="Data de Nascimento"
                    />{" "}
                  </Grid>
                ) : null}

                {showEmail ? (
                  <Grid item xs={12} md={6} lg={3}>
                    <Input
                      disableError
                      required={"*Campo Obrigatório"}
                      validation={validations.isEmailValid}
                      name="email"
                      label="E-Mail"
                      // white
                    />
                  </Grid>
                ) : null}

                {showPlate ? (
                  <Grid item xs={12} md={6} lg={3}>
                    <Input
                      disableError
                      name="vehiclePlate"
                      //mask={masks.Placa}
                      label="Placa do Veículo"
                      // white
                    />
                  </Grid>
                ) : null}

                {showPhone ? (
                  <Grid item xs={12} md={6} lg={3}>
                    <InputPhone
                      disableError
                      name="phone"
                      label="Telefone"
                      required={"*Campo Obrigatório"}
                    />
                  </Grid>
                ) : null}

                <Grid item xs={12} md={6} lg={3}>
                  <Input
                    disableError
                    required={"*Campo Obrigatório"}
                    onChange={(value) => {
                      setTotalMembers(masks.onlyNumbers(value, 0, 10));
                    }}
                    defaultValue={totalMembers}
                    mask={(value) => masks.onlyNumbers(value, 0, 10)}
                    maskToSubmit={(value) => masks.onlyNumbers(value, 0, 10)}
                    type="number"
                    name="numberUsers"
                    label="Nº Acompanhantes"
                    // white
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* Acompanhantes */}

          {drawMembers(totalMembers)}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "12px",
              paddingTop: "12px",
              width: "100%",
            }}
          >
            <CustomText
              style={{ whiteSpace: "pre-wrap" }}
              fontSize={1.75}
              textColor="#ff7733"
            >
              {unError && "*Campos Obrigatórios \n"}
              {timeError && timeError + "\n"}
              {hourError && "*" + hourError}
              {warning && "*" + warning}
            </CustomText>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "12px",
              }}
            >
              <Styles.CancelButton
                loading={loading}
                disabled={loading}
                onClick={() => {
                  customModal.close();
                }}
                fullWidth={false}
              >
                Cancelar
              </Styles.CancelButton>
              <Styles.RegitryButton
                fullWidth={false}
                loading={loading}
                disabled={loading}
                onClick={async () => {
                  const submitInfo = await formRef?.testErrorsAndReturnData();
                  const startError = checkStartData();
                  const endError = await formRef?.testFieldError("endDate");
                  console.log(startError);
                  console.log(Boolean(startError));

                  if (Boolean(startError) || Boolean(endError)) {
                    if (startError) {
                      setTimeError("Data inicial: " + startError);
                    } else {
                      setTimeError("Data final: " + endError);
                    }
                  } else {
                    setTimeError(false);
                  }

                  if (submitInfo?.hasError || hourError) {
                    setUnError(true);
                  } else {
                    setUnError(false);
                    formRef?.submit();
                  }
                }}
              >
                {edit ? "Confirmar edição" : "Confirmar Cadastro"}
              </Styles.RegitryButton>
            </div>
          </div>
        </FormFull>
      </div>
    </>
  );
}

export default RegistryReservation;
